@if (!options()) {
  <ion-toggle
    class="ion-focusable"
    justify="space-between"
    [formControl]="control()"
  >
    <h2>{{ title() }}</h2>
    <p [innerHTML]="description()"></p>
  </ion-toggle>
} @else {
  <ion-select
    [formControl]="control()"
    [interface]="isDesktop() ? 'popover' : 'action-sheet'"
    justify="space-between"
    [selectedText]="selectedText()"
    [toggleIcon]="isDesktop() ? 'chevron-down' : 'arrow-forward'"
    [interfaceOptions]="interfaceOptions()"
  >
    <div slot="label">
      <h2>{{ title() }}</h2>
      <p [innerHTML]="description()"></p>
    </div>
    @for (option of options(); track option.value) {
      <ion-select-option [value]="option.value">
        {{ option.labelKey | translate }}
      </ion-select-option>
    }
  </ion-select>
}
